exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-item[data-v-d9212b74] {\n  overflow: auto;\n  height: calc(100vh - 60px);\n}\n.qrcode[data-v-d9212b74]{\n  width:300px;\n  height:300px;\n  border: 3px solid black;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d9212b74","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/home/ScanToSearch.vue
// module id = 406
// module chunks = 1